import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NoticesWorkflowComponent} from "./notices-workflow/notices-workflow.component";
import {RouterModule, Routes} from "@angular/router";
import {AuthGuard} from "../login/auth-guard/auth.guard";
import {NoticeMetadataComponent} from "./notice-metadata/notice-metadata.component";
import {NoticeTaxpayerComponent} from "./notice-taxpayer/notice-taxpayer.component";
import {NoticeCommentsComponent} from "./notice-comments/notice-comments.component";
import {NoticeTableComponent} from "./notice-table/notice-table.component";
import {MetadataInputComponent} from "./metadata-input/metadata-input.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { NoticeModalsComponent } from './notice-modals/notice-modals.component';
import { NoticeEmailComponent } from './notice-email/notice-email.component';
import { NoticeEmailRouteResolver } from './notice-email/notice-email-route-resolver.service';
import {SharedModule} from "../../shared/shared.module";
import { ManageNoticeTypesComponent } from "./manage-notice-types/manage-notice-types.component";
import { UpdateNoticeTypeComponent } from "./update-notice-type/update-notice-type.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from "@angular/material/select";
import { DialogTitleComponent } from "../../shared/components/dialog-title/dialog-title.component";

const routes: Routes = [
  {
    path: "notices",
    component: NoticesWorkflowComponent,
    data: {
      hideSidebar: true,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "notices/:noticeId/email",
    component: NoticeEmailComponent,
    data: {
      hideSidebar: true,
    },
    resolve: {
      noticeMetadata: NoticeEmailRouteResolver,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "notices/manage-notice-types",
    component: ManageNoticeTypesComponent,
    data: {
      hideSidebar: true,
    },
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {}),
    SharedModule,
    MatDialogModule,
    MatSelectModule,
    DialogTitleComponent,
  ],
  declarations: [
    NoticesWorkflowComponent,
    NoticeMetadataComponent,
    NoticeTaxpayerComponent,
    NoticeCommentsComponent,
    NoticeTableComponent,
    MetadataInputComponent,
    NoticeModalsComponent,
    NoticeEmailComponent,
    ManageNoticeTypesComponent,
    UpdateNoticeTypeComponent
  ],
  providers: [
    NoticeEmailRouteResolver,
  ]
})
export class NoticesModule { }
